// INFO: Deprecated component
import { connect } from "react-redux";
import PrintView from "../components/PrintView";
import { setUIVisibilityState, fetchPrintNotes } from "../actions";
var mapStateToProps = function(state, _ownProps) {
    return {
        cbook: state.cbook,
        favorites: state.favorites,
        currentSlide: state.currentSlide,
        searchableSlides: state.searchableSlides.filter(function(n) {
            return !n.c || !n.c.length;
        }),
        printNotes: state.notes.printNotes
    };
};
var mapDispatchToProps = function(dispatch, ownProps) {
    return {
        close: function() {
            dispatch(setUIVisibilityState({
                state: {
                    print: false
                }
            }));
        },
        fetchPrintNotes: function() {
            dispatch(fetchPrintNotes());
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(PrintView);
